import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableRow from "./TableRow"

class TableBody extends Component {
    _renderTableContent = () => {
        const {labels, refreshList, arrSelected, onSelected} = this.props

        if (labels.length === 0) {
            return <tr>
                <td colSpan={13}>Không có dữ liệu.</td>
            </tr>
        }

        return labels.length > 0 && labels.map((item) => {
            return <TableRow key={item._id} item={item} refreshList={refreshList} arrSelected={arrSelected}
                             onSelected={onSelected}/>
        })
    }

    render() {
        return (
            <tbody className="TableBody">
            {this._renderTableContent()}
            </tbody>
        )
    }
}

TableBody.propTypes = {
    refreshList: PropTypes.func.isRequired,
    labels: PropTypes.array,
    loading: PropTypes.bool,
}

export default TableBody